import {StoryTool} from "../StoryTool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiagramProject, faFilePen, faHammer} from "@fortawesome/free-solid-svg-icons";
import {GraphsContent} from "./GraphsContent";

export class Graphs implements StoryTool {
    id = 'graphs'
    name = "Graphs"
    paths = [
        `/projects/:projectId/stories/:storyId/${this.id}`,
        `/projects/:projectId/stories/:storyId/${this.id}/:graphTab`
    ]
    enabled = true
    icon = <FontAwesomeIcon icon={faDiagramProject}/>
    entryPoint = <GraphsContent/>
    link = (projectId?: string, storyId?: string) => `/projects/${projectId}/stories/${storyId}/${this.id}`
}